import { render, staticRenderFns } from "./createpost.vue?vue&type=template&id=0f87c168&scoped=true&"
import script from "./createpost.vue?vue&type=script&lang=js&"
export * from "./createpost.vue?vue&type=script&lang=js&"
import style0 from "./createpost.vue?vue&type=style&index=0&id=0f87c168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87c168",
  null
  
)

export default component.exports